module.exports = __webpack_public_path__ + "static/coinsIcon-82e95f9eda39f291f0753a37c5d770d5.png";